import { shoppingCartAdGetRedemptionThresholdForApp } from '@/api/marketing';

const state = {
  redeemTip: '',
  redeemJumpTip: '', // 换购入口文案
  redeemPrice: 0, // 用户勾选的门槛判断价格
  reachThreshold: false, // 达到门槛价格, 未达到最低门槛为false
  thresholdList: [], // 换购门槛金额列表 [10, 20 ,30] 最多三个门槛 大贸商品门槛
  globalThresholdList: [], // 跨境商品门槛
  redeemGlobalPrice: 0, // 用户勾线跨境门槛判断价格
  reachGlobalThreshold: false,
  redeemGlobalTip: '',
  redeemGlobalJumpTip: '',
};
const actions = {
  fetchRedemptionThresholdForAppData({ commit }) {
    // 获取换购门槛
    return new Promise((resolve, reject) => {
      shoppingCartAdGetRedemptionThresholdForApp()
        .then(({ success, data }) => {
          if (success && data) {
            commit('$uStore', {
              name: 'redeem.thresholdList',
              value: data.NORMAL || [],
            });
            commit('$uStore', {
              name: 'redeem.globalThresholdList',
              value: data.GLOBAL || [],
            });
            return resolve(data.NORMAL.sort((a, b) => a - b));
          }
          reject();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /**
   * 换购门槛提示语
   * description
   * @param redeemPrice 包含：大贸商品、礼包的价格、礼包搭配区勾选的商品
   */
  getRedeemTip({ commit, state }, { redeemPrice, type }) {
    console.log('redeemPrice:' + redeemPrice);
    const { thresholdList, globalThresholdList } = state;
    const thresholdArray = type === 'GLOBAL' ? globalThresholdList : thresholdList;
    // 达到门槛价格, 未达到最低门槛为false
    const reachThreshold = getReachThreshold(thresholdArray, redeemPrice);
    // 换购提示文案：1. 再买xxx元，可享超值换购 2. 已满xxx元，可享超值换购
    const redeemTip = reachThreshold
      ? `已满${reachThreshold}元，可享超值换购`
      : `再购买${uni.$u.round(thresholdArray[0] - redeemPrice, 2)}元，可享超级换购`;
    const redeemJumpTip = reachThreshold ? `去换购` : `查看换购商品`;
    // 跨境
    if (type === 'GLOBAL') {
      commit('$uStore', {
        name: 'redeem.redeemGlobalJumpTip',
        value: redeemJumpTip,
      });
      commit('$uStore', {
        name: 'redeem.reachGlobalThreshold',
        value: reachThreshold,
      });
      commit('$uStore', {
        name: 'redeem.redeemGlobalTip',
        value: redeemTip,
      });
    } else {
      commit('$uStore', {
        name: 'redeem.reachThreshold',
        value: reachThreshold,
      });
      commit('$uStore', {
        name: 'redeem.redeemTip',
        value: redeemTip,
      });
      commit('$uStore', {
        name: 'redeem.redeemJumpTip',
        value: redeemJumpTip,
      });
    }
    return redeemTip;
  },
};

/**
 * 计算达到门槛价格
 * @param thresholdList
 * @param redeemPrice
 * @returns {boolean | number}
 */
function getReachThreshold(thresholdList, redeemPrice) {
  thresholdList.sort((a, b) => a - b);
  if (thresholdList.length === 0 || redeemPrice < thresholdList[0]) {
    return false;
  }
  let reachThreshold = thresholdList[thresholdList.length - 1];
  for (let i = 0; i < thresholdList.length; i++) {
    const item = thresholdList[i];
    if (redeemPrice < item) {
      reachThreshold = thresholdList[i - 1];
      break;
    }
    if (redeemPrice === item) {
      reachThreshold = redeemPrice;
      break;
    }
  }
  return reachThreshold;
}
export default {
  state,
  actions,
};
